"use client";

import { c as _c } from "react/compiler-runtime";
import { ptBR } from "@clerk/localizations";
import { ClerkProvider } from "@clerk/nextjs";
import { ThemeProvider, useTheme } from "next-themes";
import { NuqsAdapter } from "nuqs/adapters/next/app";
import type { ReactNode } from "react";
import { Suspense } from "react";
import ConvexClientProvider from "@/components/convex-client-provider";
import { CookieConsentBanner } from "@/components/cookie-consent-banner";
import { PostHogProvider } from "@/components/posthog-provider";
import { Toaster } from "@/components/ui/sonner";
import { useIsHydrated } from "@/hooks/use-is-hydrated";
import { getClerkAppearance } from "@/lib/auth/clerk-appearance";
import { isSignUpEnabled } from "@/lib/auth/sign-up";
import { themeStorageKey } from "@/lib/storage-keys";
function ClerkWithTheme(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const {
    theme,
    resolvedTheme
  } = useTheme();
  const isHydrated = useIsHydrated();
  const isDark = isHydrated && (theme === "dark" || resolvedTheme === "dark");
  let t1;
  if ($[0] !== isDark) {
    t1 = getClerkAppearance(isDark);
    $[0] = isDark;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const clerkAppearance = t1;
  let t2;
  if ($[2] !== children || $[3] !== clerkAppearance) {
    t2 = <ClerkProvider appearance={clerkAppearance} localization={ptBR} signInUrl="/sign-in" signUpUrl={isSignUpEnabled ? "/sign-up" : undefined} waitlistUrl="/waitlist" signInFallbackRedirectUrl="/app" signUpFallbackRedirectUrl="/app">{children}</ClerkProvider>;
    $[2] = children;
    $[3] = clerkAppearance;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export function Providers(t0) {
  const $ = _c(8);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    const nuqsContent = <Suspense><NuqsAdapter>{children}</NuqsAdapter></Suspense>;
    t1 = <ConvexClientProvider>{nuqsContent}</ConvexClientProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const convexContent = t1;
  let t2;
  if ($[2] !== convexContent) {
    t2 = <ClerkWithTheme><PostHogProvider>{convexContent}</PostHogProvider></ClerkWithTheme>;
    $[2] = convexContent;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CookieConsentBanner />;
    t4 = <Toaster />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2) {
    t5 = <ThemeProvider attribute="class" defaultTheme="system" enableSystem={true} disableTransitionOnChange={true} storageKey={themeStorageKey}>{t2}{t3}{t4}</ThemeProvider>;
    $[6] = t2;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}